module.exports = __webpack_public_path__ + "static/logo_cide_2019-623f8914554e5b9ec80ebba5edd43e53.png";